import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* ================= FETCH RATING BY ORDER ================= */
export const fetchRatingByOrder = createAsyncThunk(
  "rating/fetchByOrder",
  async (orderId, thunkAPI) => {
    try {
      const res = await api.get(`/api/ratings/order/${orderId}`);
      return res.data.data; // null if no rating exists yet
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed to fetch rating");
    }
  }
);

/* ================= SLICE ================= */
const ratingSlice = createSlice({
  name: "rating",
  initialState: {
    loading:     false,
    error:       null,
    orderRating: null,
  },
  reducers: {
    clearOrderRating: (state) => {
      state.orderRating = null;
      state.error       = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRatingByOrder.pending, (state) => {
        state.loading = true;
        state.error   = null;
      })
      .addCase(fetchRatingByOrder.fulfilled, (state, action) => {
        state.loading     = false;
        state.orderRating = action.payload;
      })
      .addCase(fetchRatingByOrder.rejected, (state, action) => {
        state.loading = false;
        state.error   = action.payload;
      });
  },
});

export const { clearOrderRating } = ratingSlice.actions;
export default ratingSlice.reducer;

/* ================= SELECTORS ================= */
export const selectOrderRating        = (state) => state.rating.orderRating;
export const selectOrderRatingLoading = (state) => state.rating.loading;
export const selectOrderRatingError   = (state) => state.rating.error;